

module.exports = __webpack_require__.stylable.create(
    "CreateGroupModal900371746",
    {"classes":{"root":"CreateGroupModal900371746__root","title":"CreateGroupModal900371746__title","logoUpload":"CreateGroupModal900371746__logoUpload","counter":"CreateGroupModal900371746__counter","nameControl":"CreateGroupModal900371746__nameControl","privacyControl":"CreateGroupModal900371746__privacyControl","label":"CreateGroupModal900371746__label","buttons":"CreateGroupModal900371746__buttons","buttonWrapper":"CreateGroupModal900371746__buttonWrapper","pendingGroupExplanation":"CreateGroupModal900371746__pendingGroupExplanation"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    9,
    "CreateGroupModal900371746",
    null
);
